var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgITumblrDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5804 0C11.883 0 0 11.883 0 26.5804C0 41.2777 11.883 53.1607 26.5804 53.1607C41.2777 53.1607 53.1607 41.2777 53.1607 26.5804C53.1607 11.883 41.2777 0 26.5804 0ZM20.7639 34.273V24.6416C19.388 24.6416 18.3874 24.6416 17.1991 24.6416C17.1991 23.078 17.1991 21.7021 17.1991 20.1385C19.8884 19.388 22.265 16.5111 23.1405 13.4465C23.4533 12.1332 23.5158 11.195 23.5158 11.195C23.5158 11.195 27.6436 11.195 28.6442 11.195C28.6442 13.9469 28.6442 16.6987 28.6442 19.388C30.7081 19.388 32.5844 19.388 34.5857 19.388V24.579C32.6469 24.579 30.7081 24.579 28.5817 24.579C28.5817 25.6422 28.5817 26.7054 28.5817 27.581C28.5817 29.5824 28.5817 31.5837 28.5817 33.5851C28.5817 38.9011 33.7101 36.7122 34.1479 36.6496L35.6489 41.5279C34.3356 42.8413 20.7639 46.156 20.7639 34.273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITumblrDesktop);
export default __webpack_public_path__ + "static/media/i_tumblr_desktop.8eaf0e91649dab59aed1af8cdef5f7fc.svg";
export { ForwardRef as ReactComponent };